import { COMPLETED_PAGES } from './manifest.js';
import { FOUNDATION_CATALOG_GROUPS } from './foundationCatalog.js';
import { BUSINESS_CATALOG_GROUPS } from './businessCatalog.js';

export const HUB_SECTIONS = [
  {
    key: 'components',
    title: '基础组件',
    subtitle: '设计系统基础组件与 Element Plus 演示',
  },
  {
    key: 'business',
    title: '业务组件',
    subtitle: '标准弹窗、导航与 B 端页面布局',
  },
  {
    key: 'completed',
    title: '已完成页面',
    subtitle: '已落地的业务主页面与设计稿',
  },
];

/**
 * @param {typeof COMPLETED_PAGES} [completedPages]
 */
export function buildHubSections(completedPages = COMPLETED_PAGES) {
  const completedItems = [...completedPages].reverse().map((p) => ({
    id: p.id,
    title: p.title,
    completedPageId: p.id,
    subtitle: p.id,
  }));

  return [
    {
      ...HUB_SECTIONS[0],
      groups: FOUNDATION_CATALOG_GROUPS,
    },
    {
      ...HUB_SECTIONS[1],
      groups: BUSINESS_CATALOG_GROUPS,
    },
    {
      ...HUB_SECTIONS[2],
      groups: [{ title: '全部', items: completedItems }],
    },
  ];
}

/** @param {ReturnType<typeof buildHubSections>} sections */
export function flattenSectionItems(section) {
  return section.groups.flatMap((g) =>
    g.items.map((item) => ({ ...item, groupTitle: g.title })),
  );
}

/** 侧栏「已完成页面」分组（仅 manifest；最新登记在前） */
export function groupCompletedPagesByCategory(pages) {
  return [{ key: 'completed', title: '已完成页面', items: [...pages].reverse() }];
}
